angular.module('invoice')
    .service('InvoiceSubstantiveDescriptionService', function ($rootScope, $cookies, toastr, modals, Principal) {
        this.editSubstantiveDescription = (invoiceId, substantiveDescription, costs) => {
            let entity = {
                id: invoiceId,
                substantiveDescription: substantiveDescription,
                costs: costs
            }
            return modals.open('app/invoice/substantive-description-edit-modal.html', 'InvoiceSubstantiveDescriptionEditController', entity, {size: "lg"}, "$ctrl")
        }
    })
